export default __webpack_public_path__ + "static/media/undo.08b80ee8.svg";